import React from "react";
import { SiteLink } from "../../components";
import { useEffect } from "react";
import utils from "../../utils";

export function Breadcrumb({ breadcrumb }) {
  const containsAirPurificationLink = breadcrumb.items?.find(
    (item) => item.link === "/air-purification"
  );
  if (containsAirPurificationLink) {
    containsAirPurificationLink.link = "/products";
  }

  // Inject breadcrumb schema.org structured data
  useEffect(() => {
    if (breadcrumb && breadcrumb.items && breadcrumb.items.length > 0) {
      // Remove any existing breadcrumb schema
      const existingSchema = document.querySelector('script[data-breadcrumb-schema="true"]');
      if (existingSchema) {
        existingSchema.remove();
      }

      // Create breadcrumb schema
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumb.items.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.title,
          "item": item.link ? utils.site.fullUrl(item.link) : utils.site.fullUrl(window.location.pathname)
        }))
      };

      // Create and inject the schema script
      const schemaScript = document.createElement('script');
      schemaScript.type = 'application/ld+json';
      schemaScript.setAttribute('data-breadcrumb-schema', 'true');
      schemaScript.textContent = JSON.stringify(breadcrumbSchema);
      
      // Inject into head for better detection
      document.head.appendChild(schemaScript);
    }

    // Cleanup function to remove schema when component unmounts
    return () => {
      const existingSchema = document.querySelector('script[data-breadcrumb-schema="true"]');
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, [breadcrumb]);

  return (
    <ul className='breadcrumb'>
      {breadcrumb.items.map((item, index) => Item(item, index))}
    </ul>
  );
}

function Item(item, index) {
  if (item.link) {
    return (
      <li key={index}>
        <SiteLink to={item.link}>{item.title}</SiteLink>
      </li>
    );
  } else {
    return <li key={index}>{item.title}</li>;
  }
}
